module.exports = __webpack_public_path__ + "img/fr.edcb0274.svg";